var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccountUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5C9.38086 8.5 10.5 7.38086 10.5 6C10.5 4.61914 9.38086 3.5 8 3.5C6.61914 3.5 5.5 4.61914 5.5 6C5.5 7.38086 6.61914 8.5 8 8.5ZM7.10742 9.4375C5.18359 9.4375 3.625 10.9961 3.625 12.9199C3.625 13.2402 3.88477 13.5 4.20508 13.5H11.7949C12.1152 13.5 12.375 13.2402 12.375 12.9199C12.375 10.9961 10.8164 9.4375 8.89258 9.4375H7.10742Z",
    fill: "#6D738D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountUser);
export default __webpack_public_path__ + "static/media/my_account_user.22a06f7e975789e47088cd8d30a64338.svg";
export { ForwardRef as ReactComponent };